__turbopack_context__.v({
  "alignItemsCenter": "_1Nz1FG_alignItemsCenter",
  "authorName": "_1Nz1FG_authorName",
  "bookBoxBody": "_1Nz1FG_bookBoxBody",
  "bookImage": "_1Nz1FG_bookImage",
  "category": "_1Nz1FG_category",
  "container": "_1Nz1FG_container",
  "dFlex": "_1Nz1FG_dFlex",
  "descriptionText": "_1Nz1FG_descriptionText",
  "desktopDescription": "_1Nz1FG_desktopDescription",
  "imgBox": "_1Nz1FG_imgBox",
  "justifyContentSpaceBetween": "_1Nz1FG_justifyContentSpaceBetween",
  "mobileDescription": "_1Nz1FG_mobileDescription",
  "mobileReviewSec": "_1Nz1FG_mobileReviewSec",
  "oldPrice": "_1Nz1FG_oldPrice",
  "previewLink": "_1Nz1FG_previewLink",
  "pricingBox": "_1Nz1FG_pricingBox",
  "pricingDetail": "_1Nz1FG_pricingDetail",
  "promoBanner": "_1Nz1FG_promoBanner",
  "promoPriceText": "_1Nz1FG_promoPriceText",
  "readPreview": "_1Nz1FG_readPreview",
  "retailerPriceText": "_1Nz1FG_retailerPriceText",
  "reviewCount": "_1Nz1FG_reviewCount",
  "reviewSec": "_1Nz1FG_reviewSec",
  "siteBox": "_1Nz1FG_siteBox",
  "siteListing": "_1Nz1FG_siteListing",
  "star": "_1Nz1FG_star",
  "titleText": "_1Nz1FG_titleText",
});
